'use client';
import { useEffect, useState } from 'react';

import { utilScrollToElement } from '@/fo/util/scroll-to-element';

import { styles } from './UiLandingNavigationBioderma.styles';

export interface Navigation {
  label: React.ReactNode;
  anchor: string;
}

export interface UiLandingNavigationBiodermaProps {
  className?: string;
  classNameItem?: string;
  classNameList?: string;
  items: Navigation[];
}

export function UiLandingNavigationBioderma({
  className,
  classNameList,
  classNameItem,
  items
}: UiLandingNavigationBiodermaProps) {
  const slots = styles();
  const [activeAnchor, setActiveAnchor] = useState<string>('');

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      for (const item of items) {
        const element = document.getElementById(item.anchor);
        if (element) {
          const rect = element.getBoundingClientRect();
          const elementTop = rect.top + scrollY;
          const elementBottom = elementTop + rect.height;

          if (
            scrollY + windowHeight / 2 >= elementTop &&
            scrollY + windowHeight / 2 <= elementBottom
          ) {
            setActiveAnchor(item.anchor);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [items]);

  const handleClick = (anchor: string) => {
    const element = document.getElementById(anchor);
    if (element) {
      utilScrollToElement(element);
    }
  };

  return (
    <div className={slots.base({ className })}>
      <ul className={slots.list({ className: classNameList })}>
        {items.map((item) => (
          <li
            className={slots.item({ className: classNameItem })}
            key={item.anchor}
          >
            <button
              className={slots.button({
                isActive: activeAnchor === item.anchor
              })}
              onClick={() => handleClick(item.anchor)}
              type="button"
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
